import { render } from "./dataTableINeedToSign.vue?vue&type=template&id=116632b9&scoped=true&ts=true"
import script from "./dataTableINeedToSign.vue?vue&type=script&lang=ts"
export * from "./dataTableINeedToSign.vue?vue&type=script&lang=ts"

import "./dataTableINeedToSign.vue?vue&type=style&index=0&id=116632b9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116632b9"]])

export default __exports__